import React from 'react';

function BuddyPanel({ buddy, buddyMood, buddyMoodLabel, buddyHappiness }) {
  return (
    <div className="buddy-container">
      <div className={`buddy buddy-${buddyMood}`}>
        {buddy.stage === 'egg' ? (
          <div
            className="buddy-emoji colored-egg"
            style={{
              background: `linear-gradient(135deg, ${buddy.getEggColorConfig().hex} 0%, ${buddy.getEggColorConfig().hex}dd 100%)`,
              borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%'
            }}
          />
        ) : (
          <div className="buddy-emoji">{buddy.getEmoji()}</div>
        )}
        <div className="buddy-name">{buddy.name}</div>
        <div className="buddy-stage">Stage: {buddy.stage}</div>
        <div className="buddy-happiness">
          <span className="buddy-happiness-label">Mood: {buddyMoodLabel}</span>
          <span className="buddy-happiness-value">{buddyHappiness}%</span>
        </div>
        <div className="buddy-happiness-bar" role="progressbar" aria-label="Buddy mood" aria-valuemin={0} aria-valuemax={100} aria-valuenow={buddyHappiness}>
          <div className={`buddy-happiness-fill mood-${buddyMood}`} style={{ width: `${buddyHappiness}%` }} />
        </div>
      </div>
    </div>
  );
}

export default BuddyPanel;
